import * as React from 'react';
import cx from 'classnames';

// Components
import { IconNavBack24 } from '@nebula/icon';

// Utils
import { isIOS } from './utils/platform';
import { getSafeAreaClassName } from '@shopee-user/with-web-view';

// Constants
import { NAVBAR_ID } from './constants';

import styles from './style.scss';

type Props = {
  // Class names
  containerClassName?: string;
  titleClassName?: string;
  iconClassName?: string;

  // Customizable elements
  icon?: React.ComponentType<any>;
  title?: string;
  rightContent?: React.ReactNode;

  // handlers
  onClickBack?: (event: React.SyntheticEvent) => void;

  shouldHideBack?: boolean;
  isResponsive?: boolean;
};

function GenericNavbar({
  containerClassName,
  titleClassName,
  iconClassName,
  icon: Icon = IconNavBack24,
  title = '',
  rightContent,
  onClickBack,
  shouldHideBack = false,
  isResponsive = true,
}: Props): JSX.Element {
  return (
    <div
      id={NAVBAR_ID}
      className={cx(
        styles.container,
        isResponsive && styles.containerResponsive,
        containerClassName,
        getSafeAreaClassName()
      )}
    >
      <div
        className={cx(styles.content, isResponsive && styles.contentResponsive)}
      >
        <div
          className={
            isIOS() ? styles.leftContainerIOS : styles.leftContainerAndroid
          }
        >
          {!shouldHideBack && (
            <div
              onClick={onClickBack}
              role="button"
              aria-label="navbar-back-button"
            >
              <Icon className={cx(styles.icon, iconClassName)} />
            </div>
          )}
        </div>
        <div
          className={cx(
            isIOS() ? styles.centerContainerIOS : styles.centerContainerAndroid,
            titleClassName
          )}
        >
          {title}
        </div>
        <div
          className={
            isIOS() ? styles.rightContainerIOS : styles.rightContainerAndroid
          }
        >
          {rightContent}
        </div>
      </div>
    </div>
  );
}

export default GenericNavbar;
